<script>
	// Stores
	import MeetingStore from '@/Stores/Racing/MeetingStore.js';
	// Components
	import Switch from '@/Components/Switch.svelte';
	// Services
	import { notify } from '@/Services/Notify.js';

	export let meeting;

	let visibleChecked = meeting && meeting.visible;

	function updateVisibility() {
		MeetingStore.updateMeetingVisibility(meeting.id, {
			visible: visibleChecked
		})
			.then(() => {
				notify({
					type: 'success',
					title: `${meeting.name}`,
					message: `Visibility updated to ${visibleChecked ? 'On' : 'Off'}`,
					timeout: 3
				});
			})
			.catch(() => {
				visibleChecked = !visibleChecked;
				notify({
					type: 'danger',
					title: `${meeting.name}`,
					message: 'Failed to update visibility',
					timeout: 3
				});
			});
	}
</script>

<div class="ml-4 mr-2 font-semibold uppercase">Visible</div>
<Switch
	on:change={updateVisibility}
	name={`visible-meeting-${meeting.id}`}
	bind:checked={visibleChecked}
	small={true}
/>
